import { render, staticRenderFns } from "./AppSpecificData.vue?vue&type=template&id=b7c004f4&scoped=true&"
import script from "./AppSpecificData.vue?vue&type=script&lang=js&"
export * from "./AppSpecificData.vue?vue&type=script&lang=js&"
import style0 from "./AppSpecificData.vue?vue&type=style&index=0&id=b7c004f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c004f4",
  null
  
)

export default component.exports